export function Spacer({ y }) {
  return <div className={`mt-${y}`} />;
}
